import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { bindUsageLifecycle, trackPage } from "@/lib/usage";

// Слушает смену маршрута и шлёт «просмотр страницы» в статистику
// использования (см. lib/usage.ts). Рендерится один раз внутри Shell.
export default function UsageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    bindUsageLifecycle();
  }, []);
  useEffect(() => {
    if (pathname.startsWith("/login")) return;
    trackPage(pathname);
  }, [pathname]);
  return null;
}
